<template>
  <component
    @show-enlarged="showEnlarged"
    :is="`${node.data.object.type}-widget`"
    :widget="node.data"
  />
</template>

<script>
  import LayerWidget from '@/components/playerWidgets/LayerWidget.vue';
  import TextWidget from '@/components/playerWidgets/TextWidget.vue';
  import ClockWidget from '@/components/playerWidgets/ClockWidget.vue';
  import ButtonWidget from '@/components/playerWidgets/ButtonWidget.vue';
  import ImageWidget from '@/components/playerWidgets/ImageWidget.vue';
  import PlaylistWidget from '@/components/playerWidgets/PlaylistWidget.vue';
  import AppWidget from '@/components/playerWidgets/AppWidget.vue';
  import VideoWidget from '@/components/playerWidgets/VideoWidget.vue';
  import PdfWidget from '@/components/playerWidgets/PdfWidget.vue';
  import TemplateWidget from '@/components/playerWidgets/TemplateWidget.vue';
  import RichtextWidget from '@/components/playerWidgets/RichtextWidget.vue';
  import AudioWidget from '@/components/playerWidgets/AudioWidget.vue';

  export default {
    name: 'WidgetNode',

    props: {
      node: {
        type: Object,
        required: true,
        default: () => {},
      },
    },

    methods: {
      showEnlarged(w) {
        this.$emit('show-enlarged', w);
      },
    },

    components: {
      AudioWidget,
      ImageWidget,
      LayerWidget,
      TextWidget,
      ClockWidget,
      ButtonWidget,
      PlaylistWidget,
      AppWidget,
      VideoWidget,
      PdfWidget,
      TemplateWidget,
      RichtextWidget,
    },
  };
</script>

<style scoped></style>
